import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { PromoListItemProps } from './PromoListItem.types';
import PromosBadgeList from '../PromosBadgeList/PromosBadgeList';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import PromoCta from '../PromoCta/PromoCta';
import { memo, useCallback } from 'react';
import PromoTimer from '../PromoTimer/PromoTimer';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { getPromos } from '../../state';

function PromoListItem({ promo, ...rest }: PromoListItemProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const dispatch = useDispatch();
  const refetchPromos = useCallback(() => dispatch(getPromos()), [dispatch]);

  const onPress = useCallback(() => {
    if (promo.contentType === 'Referrer') {
      navigation.navigate('InviteFriends');
    } else {
      navigation.navigate('PromoDetails', {
        id: promo.slug ?? promo.promotionId,
      });
    }
  }, [promo, navigation]);

  return (
    <Box
      testID={`promo-list-item-promoId:${promo.promotionId}`}
      backgroundColor="secondaryBackgroundDefault"
      borderRadius="radius-400"
      gap="space-100"
      padding="space-400"
      boxShadow={promo.isOptedIn ? 'rgb(87, 224, 74) 0px 0px 24px 0px' : 'none'}
      {...rest}
    >
      <Box flex={1} gap="space-100">
        <Box position="relative">
          {promo.promoType === 'Cashback' && promo.endDate ? (
            <PromoTimer
              promotionEndDate={promo.endDate}
              onCountDownComplete={refetchPromos}
            />
          ) : null}
          <Image
            source={promo.imageUrl}
            borderRadius="radius-400"
            width="100%"
            aspectRatio={2}
            contentFit="cover"
          />
          {promo.isOptedIn ? (
            <Image
              name="common.check"
              position="absolute"
              top="space-200"
              left="space-200"
              width={25}
              height={25}
              testID="promo-opted-in-checkmark"
            />
          ) : null}
        </Box>
        <Text
          variant="body-l-semi"
          color="darkSurfacePrimary"
          locNS="common"
          marginTop="space-100"
        >
          {promo.title}
        </Text>
        <PromosBadgeList rewards={promo.rewards} />
        <Text
          paddingTop="space-200"
          paddingBottom="space-200"
          variant="body-m-semi"
          color="darkSurfacePrimary"
        >
          {promo.shortDescription}
        </Text>
      </Box>

      <Box paddingTop="space-200" gap="space-300">
        <PromoCta promo={promo} />
        <Button
          variant="secondary"
          locNS="common"
          locKey="learnMore"
          onPress={onPress}
          alignSelf="center"
          width="100%"
        />
      </Box>
    </Box>
  );
}

export default memo(PromoListItem);
